/**
 * NOT CHECKED
 */
import React from 'react';

import BaseModal, { BaseModalType } from '@uikit/Modals/BaseModal/BaseModal';
import Button from '@uikit/Form/Button/Button';

import './ConfirmModal.scss';

type ConfirmModalType = BaseModalType & {
  title: string;
  text: string;
  confirmButtonText: string;
  isConfirmButtonMain: boolean;
  cancelButtonText: string;
  onConfirm: () => void;
  additionalStyles?: React.CSSProperties;
  /**
   * Blocks a second confirm while the first is still in flight, and puts the button in its
   * loading state. Without this the modal fired `onConfirm` on every click: the server correctly
   * refused the duplicate, but the client showed "Review is not submitted. Try again" on top of
   * the success toast for an action that had gone through.
   */
  isConfirmInFlight?: boolean;
};

function ConfirmModal({
  title,
  text,
  confirmButtonText,
  isConfirmButtonMain,
  cancelButtonText,
  isOpen,
  onClose,
  onConfirm,
  additionalStyles = null,
  isConfirmInFlight = false,
  testId,
}: ConfirmModalType): JSX.Element {
  return (
    <BaseModal
      classNames={{ closeButton: 'confirm-modal__close-btn' }}
      onClose={onClose}
      isOpen={isOpen}
      // BaseModal is `width: 100%` up to 1070px; without this the 442px dialog stretched to
      // the full overlay width (refund confirm, "Review the next placement?", etc.).
      fitWidthContent
      style={{ minHeight: 'unset', ...additionalStyles }}
      testId={testId}
    >
      <div className="confirm-modal">
        <h1 className="confirm-modal__title">{title}</h1>
        <p className="confirm-modal__message">{text}</p>
        <footer className="confirm-modal__footer">
          <Button
            className="confirm-modal__cancel-button"
            onClick={onClose}
            disabled={isConfirmInFlight}
            type={!isConfirmButtonMain ? 'primary' : 'secondary'}
            data-testid={testId ? `${testId}-cancel` : undefined}
          >
            {cancelButtonText}
          </Button>
          <Button
            className="confirm-modal__remove-button"
            onClick={onConfirm}
            disabled={isConfirmInFlight}
            isLoading={isConfirmInFlight}
            type={isConfirmButtonMain ? 'primary' : 'secondary'}
            data-testid={testId ? `${testId}-confirm` : undefined}
          >
            {confirmButtonText}
          </Button>
        </footer>
      </div>
    </BaseModal>
  );
}

export default ConfirmModal;
